import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { stringToURL } from "../../functions/conversion";
import { CircularProgress } from "@mui/material";
import StorefrontIcon from "@mui/icons-material/Storefront";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";

const Landing = () => {
  const { restaurantConfig } = useSelector((state) => state.config);
  // const [imgLoaded, setimgLoaded] = useState(false);

  return (
    <div className="landing-page">
      <h3 className="mb-3">Restaurant Outlets</h3>
      <div className="grid-landing-page">
        {restaurantConfig.outlets.map((item) => (
          <Link key={item.outletId} to={`/${item.outletId}`} className="outlet-card">
            <div className="card-left">
              <div className="icon">
                <StorefrontIcon />
              </div>
              <p>{item.outletName}</p>
            </div>
            <div className="card-right">
              <ChevronRightRoundedIcon />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Landing;
